import { ThreadHistoryModel } from '@/lib/models/user-settings/thread-history.model';
import { getTimestamp } from '@/lib/date-helpers';
import { createContext } from 'react';

export interface IThreadHistory {
  threadHistory: ThreadHistoryModel[];
  toggleArchived: (threadId: string) => void;
  togglePinned: (threadId: string) => void;
  isLoading: boolean;
}

export const ThreadHistoryContext = createContext<IThreadHistory>({
  threadHistory: [],
  toggleArchived: () => null,
  togglePinned: () => null,
  isLoading: false,
});

export const toggleArchivedInHistory = (
  threadHistory: ThreadHistoryModel[],
  threadId: string
): ThreadHistoryModel[] => {
  const historyIndex = threadHistory.findIndex((entry) => entry.threadId === threadId);
  const entry = historyIndex >= 0 ? threadHistory[historyIndex] : null;

  const next = [...threadHistory];

  if (entry?.status === 'archived') {
    next.splice(historyIndex, 1);
  } else {
    const newEntry = new ThreadHistoryModel({
      threadId,
      archivedAt: getTimestamp(new Date()) || 0,
      pinnedAt: 0,
      status: 'archived',
    });
    if (historyIndex > -1) {
      next[historyIndex] = newEntry;
    } else {
      next.unshift(newEntry);
    }
  }

  return next;
};

export const togglePinnedInHistory = (
  threadHistory: ThreadHistoryModel[],
  threadId: string
): ThreadHistoryModel[] => {
  const historyIndex = threadHistory.findIndex((entry) => entry.threadId === threadId);
  const entry = historyIndex > -1 ? threadHistory[historyIndex] : null;

  const next = [...threadHistory];

  if (entry?.status === 'pinned') {
    next.splice(historyIndex, 1);
  } else {
    const newEntry = new ThreadHistoryModel({
      threadId,
      archivedAt: 0,
      pinnedAt: getTimestamp(new Date()) || 0,
      status: 'pinned',
    });
    if (historyIndex > -1) {
      next[historyIndex] = newEntry;
    } else {
      next.unshift(newEntry);
    }
  }

  return next;
};
